__turbopack_context__.v({
  "className": "latolatin_b6d5e42e-module__p5zhiG__className",
  "variable": "latolatin_b6d5e42e-module__p5zhiG__variable",
});
